module.exports = __webpack_public_path__ + "media/images/ticket/automatic_input_ov-06969a809b9e1dc82b02e1e0dbc285f5.png";